/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：订单(order)相关的所有接口地址定义
 */
// 订单 start
// 订单详情
export const orderInfo = '/order/order-center/get-order-info'
// 订单完工
export const orderComplete = '/order/order-center/complete'
// 订单列表
export const orderList = '/order/order-center/list'
// 订单删除
export const orderDel = '/order/order-center/del-order'
// 搜索订单客户
export const orderCustomer = '/order/order-main/get-customer-list'
// 自定义常用制作项
export const commonWork = '/order/order-main/get-common-working-item'
// 制作项价格
export const workPrice = '/order/order-main/get-item-price-list'
// 搜索订单制作项
export const orderWorkByKeyword = '/order/order-main/get-working-item-by-keyword'
// 按类别搜索订单制作项
export const orderWorkByType = '/order/order-main/get-working-item-by-type'
// 保存订单
export const saveOrder = '/order/order-main/save-order'
// 时间筛选
export const timeSelect = '/order/order-center/time-select'
// 保存订单制作项
export const saveOrderDetail = '/order/order-center/update-order-detail'
// 删除订单制作项
export const delOrderDetail = '/order/order-center/del-order-detail'
// 订单线下收款
export const orderCollect = '/order/order-center/order-collect'
// 订单线下收款账户
export const accountList = '/order/order-center/account-list'
// 订单线下收款方式
export const paymentList = '/order/order-center/payment'
// 订单挂账
export const onAccount = '/order/order-center/on-account'
// 订单批量收款
export const batchCollect = '/order/order-center/batch-collect'
// 订单二维码收款
export const qrCollect = '/order/order-center/network-pay-code'
// 检查是否配置了支付宝或者微信网络支付
export const isQrcode = '/order/order-center/is-opening-network-pay'
// 订单核销
export const orderCheck = '/order/order-center/check-settlement'
// 订单暂停
export const orderStop = '/order/order-center/stop'
// 订单开始
export const orderStart = '/order/order-center/start'
// 订单作废
export const toVoid = '/order/order-center/to-void'
// 订单 end
// 工单 start
// 工单派送信息
export const getDispatch = '/order/order-center/get-dispatch'
// 工单派送分店
export const dispatchStoreList = '/order/order-center/get-store-list'
// 工单派送部门
export const dispatchDepartList = '/order/order-center/get-department-list'
// 工单派送操作
export const dispatchOperationList = '/order/order-center/get-operation-list'
// 工单派送人员
export const dispatchMemberList = '/order/order-center/get-member-list'
// 工单派送级别
export const dispatchPriorityList = '/order/order-center/get-priority-list'
// 工单派送保存
export const saveDispatch = '/order/order-center/save-dispatch'
// 工单 end
// 送货订单 start
// 送货记录
export const getDelivery = '/order/delivery-note/delivery-record'
// 送货方式
export const deliveryMethod = '/order/delivery-note/get-delivery-method'
// 送货员
export const deliveryUser = '/order/delivery-note/get-delivery-man'
// 送货公司
export const deliveryCompany = '/order/delivery-note/get-company'
// 保存送货
export const saveDelivery = '/order/delivery-note/save-delivery-note'
// 送货订单 end
// 订单绩效 start
// 获取已填写绩效记录
export const getAchievement = '/order/work-order/get-achievement'
// 绩效工序
export const getOperationList = '/order/work-order/get-operation-list'
// 获取需填写绩效的制作项
export const getAchievementItem = '/order/work-order/get-achievement-item'
// 保存绩效
export const saveAchievement = '/order/work-order/save-achievement'
// 保存绩效
export const delAchievement = '/order/work-order/del-achievement'
// 订单绩效 end



// WEBPACK FOOTER //
// ./src/api/url/order.js